export default "__VITE_ASSET__Djj9N61E__"